import { Component, OnInit, ViewChild, Inject } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AuthServerProvider } from "../shared/auth/auth.service";
import { StateService } from "@uirouter/angular";
import { PasswordOperations } from "./password-operations.component";
import { ErrorStateMatcher } from "@angular/material";
import { ConfirmPasswordErrorStateMatcher } from "./confirm-password-error-state-matcher";
import { confirmPasswordMatchValidator } from "./confirm-password-match-validator";

@Component({
    template: require('./reset-password.component.html')
})
export class ResetPassword implements OnInit {

    constructor(
        @Inject('userId') private userId: string,
        @Inject('company') private company: string,
        @Inject('token') private token: string,
        private authServerProvider: AuthServerProvider,
        private fb: FormBuilder,
        private stateService: StateService    ) { }

    resetPasswordForm: FormGroup;

    confirmPasswordErrorStateMatcher: ErrorStateMatcher = new ConfirmPasswordErrorStateMatcher();

    get Password() { return this.resetPasswordForm.get("Password"); }

    get ConfirmPassword() { return this.resetPasswordForm.get("ConfirmPassword"); }

    @ViewChild(PasswordOperations) passwordOperations: PasswordOperations;

    ngOnInit(): void {
        this.resetPasswordForm = this.fb.group(
            {
                Password: ['', Validators.required],
                ConfirmPassword: ['', Validators.required]
            },
            {
                validator: confirmPasswordMatchValidator("Password", "ConfirmPassword")
            });
    }

    onSubmit(): void {
        this.passwordOperations.performAction(
            () => this.authServerProvider.resetPassword({
                UserId: this.userId,
                Company: this.company,
                Token: this.token,
                Password: this.Password.value
            }),
            "Password has been changed",
            "Could not save new password");
    }

    cancel(): void {
        this.stateService.go("app.home");
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/password/reset-password.component.ts